export default "__VITE_ASSET__CgZYJWeY__"